import { useState } from 'react'

export interface UseModalProps {
  /** @default false */
  initiallyOpen?: boolean
}

export interface UseErrorModalProps extends UseModalProps {
  initialErrorMsg?: string
}

export interface UseModalReturn {
  isOpen: boolean
  openModal: () => void
  closeModal: () => void
}

export type UseSuccessModalReturn = UseModalReturn

export interface UseErrorModalReturn extends UseModalReturn {
  errorMsg?: string
  setErrorMsg: (errorMsg: string) => void
}

export const useModal = ({
  initiallyOpen = false,
}: UseModalProps = {}): UseModalReturn => {
  const [isOpen, setIsOpen] = useState(initiallyOpen)

  const openModal = () => setIsOpen(true)
  const closeModal = () => setIsOpen(false)

  return { isOpen, openModal, closeModal }
}

export const useSuccessModal = useModal

export const useErrorModal = ({
  initiallyOpen = false,
  initialErrorMsg = undefined,
}: UseErrorModalProps = {}): UseErrorModalReturn => {
  const { isOpen, openModal, closeModal } = useModal({ initiallyOpen })
  const [errorMsg, setErrorMsg] = useState<string | undefined>(initialErrorMsg)

  return { isOpen, openModal, closeModal, errorMsg, setErrorMsg }
}
